import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { compose } from 'redux';
import { ErrorHandler } from '@playbookux/playbook-web-core';
import withLayout from '../../../core/components/with-layout';

import Tabs from '../../constants/tabs';

import { CREATE_PRACTICE_TEST } from './graphql';

import {
  Bold,
  Button,
  Container,
  Description,
  Header,
  Segment,
  Text,
} from './styles';

const PracticeTest = () => {
  const [error, setError] = useState();
  const [createPracticeTestSession, { loading }] = useMutation(CREATE_PRACTICE_TEST);

  const handleClick = async () => {
    try {
      const {
        data: {
          createPracticeTestSession: { testSession: { id } },
        },
      } = await createPracticeTestSession();

      setError(null);

      window.open(`/unmoderated-session?session-id=${id}`);
    } catch (err) {
      setError(err);
    }
  };

  if (error) {
    return (
      <Container>
        <ErrorHandler
          error={error}
          defaultMessage="Error while retrieving Practice Test."
        />
      </Container>
    );
  }

  return (
    <Container>
      <Segment>
        <Header as="h3">
          Click “Start Study” and follow the steps to take the practice test.
        </Header>

        <Button
          onClick={handleClick}
          disabled={loading}
          loading={loading}
        >
          Start Study
        </Button>

        <Text>
          Note: You do not need to confirm if your practice test is received.
          As long as the upload progress
          has reached 100%, it has been received.
        </Text>

        <Description>
          <Text>
            Once you’ve uploaded the practice test, the PlaybookUX team will review the video -
            <Bold>&nbsp;there’s no further action required</Bold>
            . We’ll let you know if you’re approved to start testing within 7 days.
          </Text>
        </Description>
      </Segment>
    </Container>
  );
};

export default compose(
  withLayout({ selectedTab: Tabs.PRACTICE_TEST }),
)(PracticeTest);
